<div class="note-card-container" *ngIf="pinnedNotes.length">
  <div class="note-card-header">
    <h5>Pinned Notes</h5>
  </div>
  <div class="note-card-body">
    <div class="note-card" *ngFor="let note of pinnedNotes">
      <div class="note-card-actions">
        <button theme="icon" icon="preview" (click)="preview({row: note})"></button>
        <button theme="icon" icon="pin" (click)="unpin({row: note})"></button>
      </div>
      <div class="note-card-content">
        <div class="note-card-title">
          <h6>{{ note.action }}</h6>
        </div>
        <div class="note-card-text">
          <p [outerHTML]="note.comments"></p>
          <span class="date"><b>{{ note.dateAdded | date }}</b></span>
        </div>
      </div>
    </div>
  </div>
</div>
<novo-data-table 
    [dataTableService]="remoteService"
    [columns]="sharedColumns"
    [allowMultipleFilters]="true"
    [displayedColumns]="sharedDisplayColumns"
    [hideGlobalSearch]="true"
    [selectionOptions]="selectionOptions"
    [paginationOptions]="paginationOptions"
    name="cubex-notes-table"
    [activeRowIdentifier]="selectedRecordId"
    *ngIf="!loading"
    #basic>
  </novo-data-table>

<novo-loading *ngIf="loading" theme="line"></novo-loading>